import { useEffect } from 'react'
import { FieldValues, UseFormReset } from 'react-hook-form'

/**
 * Syncs the RHF form with the values. Whenever the values change, the form is reset with the new default values from the model.
 * This is useful for example when the model is updated from an API call and we want to make sure that the form is always in sync with the latest data.
 *
 * `keepDirtyValues` only updates the fields the user has not modified, so a background refetch (e.g. triggered by a successful
 * mutation invalidating the shared grid-protection queries) won't discard unsaved edits in this or another open form.
 */
function useSyncFormWithValues<T extends FieldValues>(reset: UseFormReset<T>, values: T): void {
  useEffect(() => {
    reset(values, { keepDirtyValues: true })
  }, [reset, values])
}

export default useSyncFormWithValues
